export const IdSeparator = "????";

export const ReplicationIdentifiers = {
  productSlotBooking: "psb-replica",
  updatedBooking: "updatedbooking-replica",
  untypedBooking: "untypedbooking-replica",
  productSlotState: "pss-replica",
  cashfloats: "cashfloat-replica",
  poslogs: "poslogs-replica",
  posfiles: "posfiles-replica",
  cashtransfers: "cashtransfer-replica",
  untypedTransactions: "untypedtransactions-replica",
  receiptCounters: "receiptcounters-replica",
};

export const DAILY_AUTO_UPDATE_LIMIT = 16;

// used in TicketsGrid when fetching PCs from indexDB
export const PRODUCT_CATEGORY_PAGINATION_LIMIT = 20;
